export const AUMICO_IMPORT = {
    ASSETS: 'Bilanz-Aktiva',
    LIABILITIES: 'Bilanz-Passiva',
    INCOME: 'GuV',
};
